<div class="row">
    <div class="col-lg col-md col-xs col-xl col-sm w-100 sdcCardItem">
        <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
            <div class="row pt-3">
                <div class="col-lg-2 col-md-12 col-xs-12 col-sm-6" *ngIf="btnExcluir">
                    <button mat-flat-button color="warn" (click)="delete()" class="sdcBtnSize" matTooltip="Excluir">
                        <i class="fa fa-minus fa-1x btnIcon"></i> Excluir
                    </button>
                </div>
            </div>
            <div class="row pt-3 mt-2">
                <div class="col-lg col-md">
                    <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                        floatLabel="{{formFieldFloatLabel}}">
                        <mat-label class="InputLabelColor">Amostragem Data Inicio
                            <span class="InputRequired">{{required}}</span></mat-label>
                        <input matInput id="txtAmostragem_data" #txtAmostragem_data maxlength="10"
                            [dropSpecialCharacters]="false" mask="d0/M0/0000" formControlName="amostragem_data_inicio"
                            (blur)="calcDatesEvent($event)">
                        <i matSuffix class="{{iconEnableField}}"></i>
                        <mat-hint align="start" class="InputLabelDetailsColor">
                            {{hintDate}}</mat-hint>
                        <mat-hint align="end">{{txtAmostragem_data.value.length}} / 10</mat-hint>
                        <mat-error>{{hasErrorFormControl(formulario.controls.amostragem_data_inicio)}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-lg col-md">
                    <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                        floatLabel="{{formFieldFloatLabel}}">
                        <mat-label class="InputLabelColor">Amostragem Hora Inicio
                            <span class="InputRequired">{{required}}</span></mat-label>
                        <input matInput id="txtamostragem_hora" #txtamostragem_hora maxlength="5"
                            [dropSpecialCharacters]="false" formControlName="amostragem_hora_inicio" mask="Hh:m0"
                            (blur)="calcDatesEvent($event)">
                        <i matSuffix class="{{iconEnableField}}"></i>
                        <mat-hint align="start" class="InputLabelDetailsColor">
                            {{hintHour}}</mat-hint>
                        <mat-hint align="end">{{txtamostragem_hora.value.length}} / 5</mat-hint>
                        <mat-error>{{hasErrorFormControl(formulario.controls.amostragem_hora_inicio)}}
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="col-lg col-md">
                    <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                        floatLabel="{{formFieldFloatLabel}}">
                        <mat-label class="InputLabelColor">Amostragem Data Fim
                            <span class="InputRequired">{{required}}</span></mat-label>
                        <input matInput id="txtAmostragem_data" #txtAmostragem_data maxlength="10"
                            [dropSpecialCharacters]="false" mask="d0/M0/0000" formControlName="amostragem_data_fim"
                            (blur)="calcDatesEvent($event)">
                        <i matSuffix class="{{iconEnableField}}"></i>
                        <mat-hint align="start" class="InputLabelDetailsColor">
                            {{hintDate}}</mat-hint>
                        <mat-hint align="end">{{txtAmostragem_data.value.length}} / 10</mat-hint>
                        <mat-error>{{hasErrorFormControl(formulario.controls.amostragem_data_fim)}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-lg col-md">
                    <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                        floatLabel="{{formFieldFloatLabel}}">
                        <mat-label class="InputLabelColor">Amostragem Hora Fim
                            <span class="InputRequired">{{required}}</span></mat-label>
                        <input matInput id="txtamostragem_hora" #txtamostragem_hora maxlength="5"
                            [dropSpecialCharacters]="false" formControlName="amostragem_hora_fim" mask="Hh:m0"
                            (blur)="calcDatesEvent($event)">
                        <i matSuffix class="{{iconEnableField}}"></i>
                        <mat-hint align="start" class="InputLabelDetailsColor">
                            {{hintHour}}</mat-hint>
                        <mat-hint align="end">{{txtamostragem_hora.value.length}} / 5</mat-hint>
                        <mat-error>{{hasErrorFormControl(formulario.controls.amostragem_hora_fim)}}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="row pt-3">
                <div class="col-lg col-md">
                    <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                        floatLabel="{{formFieldFloatLabel}}">
                        <mat-label class="InputLabelColor">Amostra 1 de Umidade
                            <span class="InputRequired">{{required}}</span></mat-label>
                        <input matInput id="txtAmostra1" #txtAmostra1 maxlength="5" formControlName="amostra_1_umidade"
                            currencyMask [options]="{ thousands: '.', decimal: ',', precision: 2 }"
                            (blur)="makeCalculations()">

                        <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                    </mat-form-field>
                </div>
                <div class="col-lg col-md">
                    <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                        floatLabel="{{formFieldFloatLabel}}">
                        <mat-label class="InputLabelColor">Amostra 2 de Umidade
                            <span class="InputRequired">{{required}}</span></mat-label>
                        <input matInput id="txtAmostra2" #txtAmostra2 maxlength="5" formControlName="amostra_2_umidade"
                            currencyMask [options]="{ thousands: '.', decimal: ',', precision: 2 }"
                            (blur)="makeCalculations()">

                        <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                    </mat-form-field>
                </div>
                <div class="col-lg col-md">
                    <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                        floatLabel="{{formFieldFloatLabel}}">
                        <mat-label class="InputLabelColor">Amostra 3 de Umidade</mat-label>
                        <input matInput id="txtAmostra3" #txtAmostra3 maxlength="5" formControlName="amostra_3_umidade"
                            currencyMask [options]="{ thousands: '.', decimal: ',', precision: 2 }"
                            (blur)="makeCalculations()">

                        <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                    </mat-form-field>
                </div>
                <div class="col-lg col-md">
                    <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                        floatLabel="{{formFieldFloatLabel}}">
                        <mat-label class="InputLabelColor">Umidade Média
                            <span class="InputRequired">{{required}}</span></mat-label>
                        <input matInput id="txtUmidadeMedia" #txtUmidadeMedia maxlength="5"
                            formControlName="umidade_media" currencyMask
                            [options]="{ thousands: '.', decimal: ',', precision: 2 }" readonly class="InputBlockColor">
                        <i matSuffix class="{{iconDisableField}}"></i>
                        <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                    </mat-form-field>
                </div>
            </div>

            <div class="row pt-3">
                <div class="col-lg col-md">
                    <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                        floatLabel="{{formFieldFloatLabel}}">
                        <mat-label class="InputLabelColor">Andar do Secador
                            <span class="InputRequired">{{required}}</span></mat-label>
                        <input matInput id="txtAndarSecador" #txtAndarSecador maxlength="5"
                            formControlName="andar_secador" currencyMask
                            [options]="{ thousands: '.', decimal: ',', precision: 0 }">
                        <mat-error>Apenas os valores 1,2 ou 3 são aceitos.
                        </mat-error>
                        <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                    </mat-form-field>
                </div>
                <div class="col-lg col-md">
                    <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                        floatLabel="{{formFieldFloatLabel}}">
                        <mat-label class="InputLabelColor">Número do Secador
                            <span class="InputRequired">{{required}}</span></mat-label>
                        <input matInput id="txtNumeroSecador" #txtNumeroSecador maxlength="5"
                            formControlName="numero_secador" currencyMask
                            [options]="{ thousands: '.', decimal: ',', precision: 0 }" (blur)="setSecagemFrio($event)">
                        <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                        <mat-error>Apenas os valores 1,2 ou 3 são aceitos.
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-lg col-md">
                    <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                        floatLabel="{{formFieldFloatLabel}}">
                        <mat-label class="InputLabelColor">Número do Dumper
                            <span class="InputRequired">{{required}}</span></mat-label>
                        <input matInput id="txtNumeroDumper" #txtNumeroDumper maxlength="5"
                            formControlName="numero_dumper" currencyMask
                            [options]="{ thousands: '.', decimal: ',', precision: 0 }">
                        <mat-error>Apenas os valores no intervalo de 1 a 18 são aceitos.
                        </mat-error>
                        <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                    </mat-form-field>
                </div>
            </div>

            <div class="row pt-3">
                <div class="col-lg col-md">
                    <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                        floatLabel="{{formFieldFloatLabel}}">
                        <mat-label class="InputLabelColor">Secagem a Frio?
                            <span class="InputRequired">{{required}}</span></mat-label>
                        <input matInput #txtSecagemFrio maxlength="3" formControlName="secagem_frio" readonly
                            class="InputBlockColor">
                        <i matSuffix class="{{iconDisableField}}"></i>
                        <mat-hint align="end">{{txtSecagemFrio.value?.length || 0}}/3</mat-hint>
                    </mat-form-field>
                </div>
                <div class="col-lg col-md">
                    <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                        floatLabel="{{formFieldFloatLabel}}">
                        <mat-label class="InputLabelColor">Finalizou secagem da Caixa?
                            <span class="InputRequired">{{required}}</span></mat-label>
                        <input matInput #txtFinalizouSecagemCaixa maxlength="3"
                            formControlName="finalizou_secagem_caixa" readonly class="InputBlockColor">
                        <mat-hint align="end">{{txtFinalizouSecagemCaixa.value?.length || 0}}/3</mat-hint>
                    </mat-form-field>
                </div>
            </div>
            <div class="row pt-3">
                <div class="col-lg col-md">
                    <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                        floatLabel="{{formFieldFloatLabel}}">
                        <mat-label class="InputLabelColor">Ressecagem?
                            <span class="InputRequired">{{required}}</span></mat-label>
                        <mat-select #txtSafra formControlName="Ressecagem" (selectionChange)="calcDatesEvent($event)"
                            disableOptionCentering>
                            <mat-option *ngFor="let item of listRessecagem" [value]="item.name">
                                {{item.name | uppercase}}
                            </mat-option>
                        </mat-select>
                        <i matSuffix class="{{iconEnableField}}"></i>
                        <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                    </mat-form-field>
                </div>
                <div class="col-lg col-md">
                    <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                        floatLabel="{{formFieldFloatLabel}}">
                        <mat-label class="InputLabelColor">Peso Pós Secagem (Kg)
                            <span class="InputRequired">{{required}}</span></mat-label>
                        <input matInput id="txtPesoPosSecagem" #txtPesoPosSecagem formControlName="peso_pos_secagem"
                            currencyMask [options]="{ thousands: '.', decimal: ',', precision: 2 }">
                        <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                    </mat-form-field>
                </div>
                <!-- <div class="col-lg col-md">
                    <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                        floatLabel="{{formFieldFloatLabel}}">
                        <mat-label class="InputLabelColor">Rendimento pos secagem/RW
                            <span class="InputRequired">{{required}}</span></mat-label>
                        <input matInput id="txtRendimentoPosSecagem" #txtRendimentoPosSecagem
                            formControlName="rendimento_pos_secagem"  currencyMask
                            [options]="{ thousands: '.', decimal: ',', precision: 2, suffix: '%'}"  readonly
                            class="InputBlockColor">                         
                        <i matSuffix class="{{iconDisableField}}"></i>
                        <mat-error>Verificar lançamentos, o peso pós secagem está maior que o peso RW</mat-error>
                        <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                    </mat-form-field>
                </div> -->
            </div>
        </form>
    </div>